// @flow

import React from 'react'
import './style.css'

export default function Preloader(): React$Element<'div'> {
  return <div className="loader">Loading...</div>
}
